import React from "react";
import storia from "../../json/storia.json";
import MasterHeadImg2 from "@/utilities/MasterHeadImg2";
import ImgText from "@/utilities/Sections/Img&Text";
import TimeLine from "@/utilities/TimeLine";
import { NewsLetter } from "@/utilities/NewsLetter";
import PageHead from "@/utilities/Head";
import SEO from "../../json/SEO.json";
import styles from "@/styles/ourStory.module.css";
import BrunoFamily from "@/utilities/BrunoFamily/BrunoFamily";
import OurMap from "@/utilities/OurMap/OurMap";
import OurStory from "@/utilities/OurStory/OurStory";

export default function Storia({ version }) {

    const { masterHead, section, timeline,timelineDesc, newsletter } = storia[version] || {};
    return (
        <section>
            <PageHead content={SEO[version]?.storia?.SEO} />
            <MasterHeadImg2 data={masterHead} />
            <div className={styles.container}>
                <div className={styles.desc}>
                    <h2>{timelineDesc}</h2>
                </div>
            </div>
          
            <TimeLine data={timeline} />
            <BrunoFamily/>
            <OurMap/>
            <ImgText data={section} />
            <OurStory/>
        
            {/* <NewsLetter content={newsletter} /> */}
        </section>
    )

      
}
